export enum Environment {
	LOCALPROXI,
	LOCAL,
	DEV,
	DEV2019,
	UAT,
	TEST,
	PROD,
}
/**
 * Change this {currentEnv} variable to change the current environment
 * TODO: these endpoints should be created as Environment Variables and currentEnv
 * should be done in the buildspec
 */

//export const currentEnv = Environment.LOCAL;
//export const currentEnv = Environment.LOCALPROXI;
//export const currentEnv = Environment.DEV;
//export const currentEnv = Environment.UAT;
//export const currentEnv = Environment.PROD;

// Function to map the environment variable to the enum
function mapEnvironment(envVariable: string) {
	switch (envVariable) {
		case 'DEV':
			return Environment.DEV;
		case 'DEV2019':
			return Environment.DEV2019;
		case 'UAT':
			return Environment.UAT;
		case 'TEST':
			return Environment.TEST;
		case 'PROD':
			return Environment.PROD;
		case 'LOCAL':
			return Environment.LOCAL;
		case 'LOCALPROXI':
			return Environment.LOCALPROXI;
		default:
			// Default case if the environment variable is not set or doesn't match
			return Environment.LOCAL; // or any other default you prefer
	}
}

// Read the environment variable and set the current environment.
export const currentEnv = mapEnvironment(process.env.REACT_APP_ENVIRONMENT || 'DEV');

//export const currentEnv = Environment.DEV;

//Refresh token time interval in msec.
//This setting should be <= liifespan of the access token
// and also <= refreshtoken cookie expiration date
export const getRefreshTokenInterval = (environment: any): number => {
	switch (environment) {
		case Environment.DEV:
			// 30 sec
			return 900000; //30000;
		case Environment.DEV2019:
			// 30 sec
			return 900000; //30000;
		case Environment.UAT:
			// 15 min
			return 900000;
		case Environment.TEST:
			// 15 min
			return 900000;
		case Environment.PROD:
			//15 min.
			return 900000;
		default:
			return 30000;
	}
};
//withCredentials:true option makes browser to send user credentails which are required for sending HTTPOnly cookie in the client request.
export const getWithCredentialsOption = (environment: any): boolean => {
	switch (environment) {
		case Environment.DEV:
			return true;
		case Environment.DEV2019:
			return true;
		case Environment.UAT:
			return true;
		case Environment.TEST:
			return true;
		case Environment.PROD:
			return true;
		default:
			return true;
	}
};
interface IEndpoints {
	LOGIN: string;
	LOGOUT: string;
	REFRESH_JWT_TOKEN: string;
	REGISTER: string;
	ACTIVATE: string;
	DEACTIVATE: string;
	RESET_PASSWORD: string;
	FORGOT_PASSWORD: string;
	LOGIN_MFA: string;
	SETUP_MFA: string;
	VERIFY_MFA: string;
	LOGIN_EMAIL_MFA: string;
	SETUP_EMAIL_MFA: string;
	VERIFY_EMAIL_MFA: string;
	BROKER_PORTAL_BACKEND_VERSION?: string;
	GET_ABN_CLIENTS_BY_NAME: string;
	GET_ABN_CLIENT_BY_ABN_NUMBER: string;
	GET_ACN_CLIENT_BY_ACN_NUMBER: string;
	GET_ACN_CLIENTS_BY_NAME: string;
	GET_CLIENT_ENTITY_GROUP: string;
	GET_PACKAGES_BY_SUBOCCUPATION_ID?: string;
	GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE: string;
	SAVE_CLIENT_TO_DB?: string;
	GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER: string;
	GET_CLIENT_MICROSERVICE_VERSION?: string;
	SEARCH_SANCTIONS_BY_CLIENT: string;
	GET_BROKER_DETAILS_BY_USERNAME?: string;
	GET_BROKER_DETAILS_BY_ID: string;
	GET_QUOTE_GROUP_BY_QUOTE_ID: string;
	GET_QUOTE_GROUPS_BY_BROKER_ID: string;
	CREATE_QUOTE_GROUP: string;
	UPDATE_QUOTE_GROUP: string;
	BIND_QUOTE_GROUP: string;
	REFER_QUOTE_GROUP: string;
	GET_POLICY_WORDING?: string;
	GET_WORDING_BY_QUOTE_ID?: string;
	UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE: string;
	GET_DOCUMENT_BY_QUOTE_ID: string;
}

// DEV2-2019
// https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/quote-get-policy-wording
// UAT
// https://ghqqpwgyo3.execute-api.ap-southeast-2.amazonaws.com/delta-microservices-web-api-uat/quote-get-policy-wording
// TEST:
// https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-policy-wording
// PROD:
// https://mpw93an6vf.execute-api.ap-southeast-2.amazonaws.com/delta-microservices-stage-prod/quote-get-policy-wording

export const endpointsReference = {
	[Environment.LOCAL]: {
		LOGIN: 'https://local.deltainsurance.co.nz:7149/login',
		LOGOUT: 'https://local.deltainsurance.co.nz:7149/logout',
		REFRESH_JWT_TOKEN: 'https://local.deltainsurance.co.nz:7149/refresh-token',
		REGISTER: 'https://local.deltainsurance.co.nz:7149/register',
		ACTIVATE: 'https://local.deltainsurance.co.nz:7149/activate',
		DEACTIVATE: 'https://local.deltainsurance.co.nz:7149/deactivate',
		RESET_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ResetPassword',
		FORGOT_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ForgotPassword',
		LOGIN_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/loginMFA',
		SETUP_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupMfa',
		VERIFY_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifyMfa',
		LOGIN_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/LoginEmailMfa',
		SETUP_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupEmailMfa',
		VERIFY_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifySetupEmailMfa',
		GET_ABN_CLIENT_BY_ABN_NUMBER: 'https://local.deltainsurance.co.nz:7272/GetAbnClientByAbn',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-acn-clients-by-name',
		SAVE_CLIENT_TO_DB:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-update-client-address',
		GET_ABN_CLIENTS_BY_NAME: 'https://localhost:7272/GetAbnClientsByName',
		GET_CLIENT_ENTITY_GROUP:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-client-entity-group',
		SEARCH_SANCTIONS_BY_CLIENT: 'https://localhost:7272/client-sanctions-by-client',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER: 'https://localhost:7272/GetSubOccupation',
		GET_BROKER_DETAILS_BY_ID: 'https://localhost:7178/Broker/GetBrokerById',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://localhost:7179/Quote/GetProductsByOccupationAndEntity',
		GET_QUOTE_GROUP_BY_QUOTE_ID: 'https://localhost:7179/Quote/GetQuoteGroupById',
		GET_QUOTE_GROUPS_BY_BROKER_ID: 'https://localhost:7179/Quote/GetQuoteGroupsByBrokerFirm',
		CREATE_QUOTE_GROUP: 'https://localhost:7179/Quote/CreateQuoteGroup',
		UPDATE_QUOTE_GROUP: 'https://localhost:7179/Quote/UpdateQuoteGroup',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://dr8m3ctdm2.execute-api.ap-southeast-2.amazonaws.com/broker-portal-frontenddev/update-quote-group-status-to-referral-approved-modifiable',
		BIND_QUOTE_GROUP: 'https://localhost:7179/Quote/BindQuoteGroup',
		REFER_QUOTE_GROUP: 'https://localhost:7179/Quote/ReferQuoteGroup',
		GET_DOCUMENT_BY_QUOTE_ID: 'https://localhost:7179/Quote/GetDocumentByQuoteId',
	} as IEndpoints,
	[Environment.LOCALPROXI]: {
		LOGIN: 'https://local.deltainsurance.co.nz:8089/auth/login',
		LOGOUT: 'https://local.deltainsurance.co.nz:8089/auth/logout',
		REFRESH_JWT_TOKEN: 'https://local.deltainsurance.co.nz:8089/auth/refresh-token',
		REGISTER: 'https://local.deltainsurance.co.nz:8089/auth/register',
		ACTIVATE: 'https://local.deltainsurance.co.nz:8089/auth/activate',
		DEACTIVATE: 'https://local.deltainsurance.co.nz:8089/auth/deactivate',
		RESET_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ResetPassword',
		FORGOT_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ForgotPassword',
		LOGIN_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/loginMFA',
		SETUP_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupMfa',
		VERIFY_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifyMfa',
		LOGIN_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/LoginEmailMfa',
		SETUP_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupEmailMfa',
		VERIFY_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifySetupEmailMfa',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://local.deltainsurance.co.nz:8089/client/GetAbnClientByAbn',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-acn-clients-by-name',
		SAVE_CLIENT_TO_DB:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-update-client-address',
		GET_CLIENT_ENTITY_GROUP:
			'https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/client-get-client-entity-group',
		GET_ABN_CLIENTS_BY_NAME:
			'https://local.deltainsurance.co.nz:8089/client/GetAbnClientsByName',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://local.deltainsurance.co.nz:8089/client/client-sanctions-by-client',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://local.deltainsurance.co.nz:8089/client/GetSubOccupation',
		GET_BROKER_DETAILS_BY_ID:
			'https://local.deltainsurance.co.nz:8089/broker/Broker/GetBrokerById',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://local.deltainsurance.co.nz:8089/quote/Quote/GetProductsByOccupationAndEntity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://local.deltainsurance.co.nz:8089/quote/Quote/GetQuoteGroupById',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://local.deltainsurance.co.nz:8089/quote/Quote/GetQuoteGroupsByBrokerFirm',
		CREATE_QUOTE_GROUP: 'https://local.deltainsurance.co.nz:8089/quote/Quote/CreateQuoteGroup',
		UPDATE_QUOTE_GROUP: 'https://local.deltainsurance.co.nz:8089/quote/Quote/UpdateQuoteGroup',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://dr8m3ctdm2.execute-api.ap-southeast-2.amazonaws.com/broker-portal-frontenddev/update-quote-group-status-to-referral-approved-modifiable',
		BIND_QUOTE_GROUP: 'https://local.deltainsurance.co.nz:8089/quote/Quote/BindQuoteGroup',
		REFER_QUOTE_GROUP: 'https://local.deltainsurance.co.nz:8089/quote/Quote/ReferQuoteGroup',
		GET_DOCUMENT_BY_QUOTE_ID: 
			'https://local.deltainsurance.co.nz:8089/quote/Quote/GetDocumentByQuoteId',
	} as IEndpoints,
	[Environment.DEV]: {
		LOGIN: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/login',
		LOGOUT: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/logout',
		REFRESH_JWT_TOKEN:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/refresh-token',
		REGISTER: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/register',
		ACTIVATE: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/activate',
		DEACTIVATE: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/deactivate',
		RESET_PASSWORD:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/ResetPassword',
		FORGOT_PASSWORD:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/ForgotPassword',
		LOGIN_MFA: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/loginMFA',
		SETUP_MFA: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/SetupMfa',
		VERIFY_MFA: 'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/VerifyMfa',
		LOGIN_EMAIL_MFA:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/LoginEmailMfa',
		SETUP_EMAIL_MFA:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/SetupEmailMfa',
		VERIFY_EMAIL_MFA:
			'https://dimsuat8.deltainsurance.co.nz/TestBPWebAPIFrontendDev/VerifySetupEmailMfa',
		GET_ABN_CLIENTS_BY_NAME:
			'https://bpapidev.deltainsurance.co.nz/client-get-abn-clients-by-name',
		GET_CLIENT_ENTITY_GROUP:
			'https://bpapidev.deltainsurance.co.nz/client-get-client-entity-group',
		SAVE_CLIENT_TO_DB: 'https://bpapidev.deltainsurance.co.nz/client-update-client-address',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://bpapidev.deltainsurance.co.nz/client-sanctions-by-client',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://bpapidev.deltainsurance.co.nz/client-get-client-by-abn',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://bpapidev.deltainsurance.co.nz/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://bpapidev.deltainsurance.co.nz/client-get-acn-clients-by-name',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://bpapidev.deltainsurance.co.nz/client-get-suboccupation',
		GET_BROKER_DETAILS_BY_ID: 'https://bpapidev.deltainsurance.co.nz/broker-get-broker-by-id',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://bpapidev.deltainsurance.co.nz/quote-get-products-by-occupation-and-entity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://bpapidev.deltainsurance.co.nz/quote-quote-groups-by-group-id',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://bpapidev.deltainsurance.co.nz/quote-get-firm-quote-groups-by-broker-id',
		CREATE_QUOTE_GROUP: 'https://bpapidev.deltainsurance.co.nz/quote-create-quote-group',
		UPDATE_QUOTE_GROUP: 'https://bpapidev.deltainsurance.co.nz/quote-update-quote-group',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://bpapidev.deltainsurance.co.nz/update-quote-group-status-to-referral-approved-modifiable',
		BIND_QUOTE_GROUP: 'https://bpapidev.deltainsurance.co.nz/quote-bind-guote-group',
		REFER_QUOTE_GROUP: 'https://bpapidev.deltainsurance.co.nz/quote-quote-group-referral',
		GET_POLICY_WORDING: 'https://bpapidev.deltainsurance.co.nz/quote-get-policy-wording',
		GET_WORDING_BY_QUOTE_ID: 'https://bpapidev.deltainsurance.co.nz/quote-get-wording-by-quote-id',
		GET_DOCUMENT_BY_QUOTE_ID: 'https://bpapidev.deltainsurance.co.nz/quote-get-document',
	} as IEndpoints,
	[Environment.DEV2019]: {
		ACTIVATE: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/activate',
		DEACTIVATE: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/deactivate',
		FORGOT_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ForgotPassword',
		LOGIN: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/login',
		LOGIN_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/LoginEmailMfa',
		LOGIN_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/loginMFA',
		LOGOUT: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/logout',
		REFRESH_JWT_TOKEN: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/refresh-token',
		REGISTER: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/register',
		RESET_PASSWORD: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/ResetPassword',
		SETUP_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupEmailMfa',
		SETUP_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/SetupMfa',
		VERIFY_EMAIL_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifySetupEmailMfa',
		VERIFY_MFA: 'https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/VerifyMfa',

		BIND_QUOTE_GROUP: 'https://bpapidev6.deltainsurance.co.nz/quote-bind-guote-group',
		CREATE_QUOTE_GROUP: 'https://bpapidev6.deltainsurance.co.nz/quote-create-quote-group',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://bpapidev6.deltainsurance.co.nz/client-get-client-by-abn',
		GET_ABN_CLIENTS_BY_NAME:
			'https://bpapidev6.deltainsurance.co.nz/client-get-abn-clients-by-name',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://bpapidev6.deltainsurance.co.nz/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://bpapidev6.deltainsurance.co.nz/client-get-acn-clients-by-name',
		GET_BROKER_DETAILS_BY_ID: 'https://bpapidev6.deltainsurance.co.nz/broker-get-broker-by-id',
		GET_CLIENT_ENTITY_GROUP:
			'https://bpapidev6.deltainsurance.co.nz/client-get-client-entity-group',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://bpapidev6.deltainsurance.co.nz/client-get-suboccupation',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://bpapidev6.deltainsurance.co.nz/quote-get-products-by-occupation-and-entity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://bpapidev6.deltainsurance.co.nz/quote-quote-groups-by-group-id',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://bpapidev6.deltainsurance.co.nz/quote-get-firm-quote-groups-by-broker-id',
		GET_POLICY_WORDING: 'https://bpapidev6.deltainsurance.co.nz/quote-get-policy-wording',
		GET_WORDING_BY_QUOTE_ID: 'https://bpapidev6.deltainsurance.co.nz/quote-get-wording-by-quote-id',
		REFER_QUOTE_GROUP: 'https://bpapidev6.deltainsurance.co.nz/quote-quote-group-referral',
		SAVE_CLIENT_TO_DB: 'https://bpapidev6.deltainsurance.co.nz/client-update-client-address',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://bpapidev6.deltainsurance.co.nz/client-sanctions-by-client',
		UPDATE_QUOTE_GROUP: 'https://bpapidev6.deltainsurance.co.nz/quote-update-quote-group',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://bpapidev6.deltainsurance.co.nz/update-quote-group-status-to-referral-approved-modifiable',
		GET_DOCUMENT_BY_QUOTE_ID: 'https://bpapidev6.deltainsurance.co.nz/quote-get-document',
	} as IEndpoints,
	[Environment.UAT]: {
		LOGIN: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/login',
		LOGOUT: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/logout',
		REFRESH_JWT_TOKEN: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/refresh-token',
		REGISTER: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/register',
		ACTIVATE: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/activate',
		DEACTIVATE: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebAPIUat/deactivate',
		RESET_PASSWORD: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/ResetPassword',
		FORGOT_PASSWORD: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/ForgotPassword',
		LOGIN_MFA: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/LoginMFA',
		SETUP_MFA: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/SetupMfa',
		VERIFY_MFA: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/VerifyMfa',
		LOGIN_EMAIL_MFA: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/LoginEmailMfa',
		SETUP_EMAIL_MFA: 'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/SetupEmailMfa',
		VERIFY_EMAIL_MFA:
			'https://dimsuat7.deltainsurance.co.nz/TestBPWebApiUat/VerifySetupEmailMfa',
		GET_ABN_CLIENTS_BY_NAME:
			'https://bpapiuat.deltainsurance.co.nz/client-get-abn-clients-by-name',
		GET_CLIENT_ENTITY_GROUP:
			'https://bpapiuat.deltainsurance.co.nz/client-get-client-entity-group',
		SAVE_CLIENT_TO_DB: 'https://bpapiuat.deltainsurance.co.nz/client-update-client-address',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://bpapiuat.deltainsurance.co.nz/client-sanctions-by-client',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://bpapiuat.deltainsurance.co.nz/client-get-client-by-abn',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://bpapiuat.deltainsurance.co.nz/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://bpapiuat.deltainsurance.co.nz/client-get-acn-clients-by-name',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://bpapiuat.deltainsurance.co.nz/client-get-suboccupation',
		GET_BROKER_DETAILS_BY_ID: 'https://bpapiuat.deltainsurance.co.nz/broker-get-broker-by-id',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://bpapiuat.deltainsurance.co.nz/quote-get-products-by-occupation-and-entity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://bpapiuat.deltainsurance.co.nz/quote-quote-groups-by-group-id',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://bpapiuat.deltainsurance.co.nz/quote-get-firm-quote-groups-by-broker-id',
		CREATE_QUOTE_GROUP: 'https://bpapiuat.deltainsurance.co.nz/quote-create-quote-group',
		UPDATE_QUOTE_GROUP: 'https://bpapiuat.deltainsurance.co.nz/quote-update-quote-group',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://bpapiuat.deltainsurance.co.nz/update-quote-group-status-to-referral-approved-modifiable',
		BIND_QUOTE_GROUP: 'https://bpapiuat.deltainsurance.co.nz/quote-bind-guote-group',
		REFER_QUOTE_GROUP: 'https://bpapiuat.deltainsurance.co.nz/quote-quote-group-referral',
		GET_POLICY_WORDING: 'https://bpapiuat.deltainsurance.co.nz/quote-get-policy-wording',
		GET_WORDING_BY_QUOTE_ID: 'https://bpapiuat.deltainsurance.co.nz/quote-get-wording-by-quote-id',
		GET_DOCUMENT_BY_QUOTE_ID: 
			'https://bpapiuat.deltainsurance.co.nz/quote-get-document',
	} as IEndpoints,
	[Environment.TEST]: {
		LOGIN: 'https://bptest.deltainsurance.co.nz/BPWebApi/login',
		LOGOUT: 'https://bptest.deltainsurance.co.nz/BPWebApi/logout',
		REFRESH_JWT_TOKEN: 'https://bptest.deltainsurance.co.nz/BPWebApi/refresh-token',
		REGISTER: 'https://bptest.deltainsurance.co.nz/BPWebApi/register',
		ACTIVATE: 'https://bptest.deltainsurance.co.nz/BPWebApi/activate',
		DEACTIVATE: 'https://bptest.deltainsurance.co.nz/BPWebApi/deactivate',
		RESET_PASSWORD: 'https://bptest.deltainsurance.co.nz/BPWebApi/ResetPassword',
		FORGOT_PASSWORD: 'https://bptest.deltainsurance.co.nz/BPWebApi/ForgotPassword',
		LOGIN_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/LoginMFA',
		SETUP_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/SetupMfa',
		VERIFY_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/VerifyMfa',
		LOGIN_EMAIL_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/LoginEmailMfa',
		SETUP_EMAIL_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/SetupEmailMfa',
		VERIFY_EMAIL_MFA: 'https://bptest.deltainsurance.co.nz/BPWebApi/VerifySetupEmailMfa',
		GET_ABN_CLIENTS_BY_NAME:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/client-get-abn-clients-by-name',
		GET_CLIENT_ENTITY_GROUP: '',
		SAVE_CLIENT_TO_DB:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/client-update-client-address',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/client-sanctions-by-client',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/client-get-client-by-abn',
		GET_ACN_CLIENT_BY_ACN_NUMBER: '',
		GET_ACN_CLIENTS_BY_NAME: '',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/client-get-suboccupation',
		GET_BROKER_DETAILS_BY_ID:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/broker-get-broker-by-id',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-products-by-occupation-and-entity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-quote-groups-by-group-id',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-firm-quote-groups-by-broker-id',
		CREATE_QUOTE_GROUP:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-create-quote-group',
		UPDATE_QUOTE_GROUP:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-update-quote-group',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE: '',
		BIND_QUOTE_GROUP:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-bind-guote-group',
		REFER_QUOTE_GROUP:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-quote-group-referral',
		GET_POLICY_WORDING:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-policy-wording',
		GET_WORDING_BY_QUOTE_ID:
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-wording-by-quote-id',
		GET_DOCUMENT_BY_QUOTE_ID: 
			'https://pje0fxjfp0.execute-api.ap-southeast-2.amazonaws.com/bptest-api-gateway/quote-get-document',
	} as IEndpoints,
	[Environment.PROD]: {
		LOGIN: 'https://bp.deltainsurance.co.nz/BPWebApi/login',
		LOGOUT: 'https://bp.deltainsurance.co.nz/BPWebApi/logout',
		REFRESH_JWT_TOKEN: 'https://bp.deltainsurance.co.nz/BPWebApi/refresh-token',
		REGISTER: 'https://bp.deltainsurance.co.nz/BPWebApi/register',
		ACTIVATE: 'https://bp.deltainsurance.co.nz/BPWebApi/activate',
		DEACTIVATE: 'https://bp.deltainsurance.co.nz/BPWebApi/deactivate',
		RESET_PASSWORD: 'https://bp.deltainsurance.co.nz/BPWebApi/ResetPassword',
		FORGOT_PASSWORD: 'https://bp.deltainsurance.co.nz/BPWebApi/ForgotPassword',
		LOGIN_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/LoginMFA',
		SETUP_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/SetupMfa',
		VERIFY_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/VerifyMfa',
		LOGIN_EMAIL_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/LoginEmailMfa',
		SETUP_EMAIL_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/SetupEmailMfa',
		VERIFY_EMAIL_MFA: 'https://bp.deltainsurance.co.nz/BPWebApi/VerifySetupEmailMfa',
		GET_ABN_CLIENTS_BY_NAME:
			'https://bpapiprod.deltainsurance.co.nz/client-get-abn-clients-by-name',
		GET_CLIENT_ENTITY_GROUP:
			'https://bpapiprod.deltainsurance.co.nz/client-get-client-entity-group',
		SAVE_CLIENT_TO_DB: 'https://bpapiprod.deltainsurance.co.nz/client-update-client-address',
		SEARCH_SANCTIONS_BY_CLIENT:
			'https://bpapiprod.deltainsurance.co.nz/client-sanctions-by-client',
		GET_ABN_CLIENT_BY_ABN_NUMBER:
			'https://bpapiprod.deltainsurance.co.nz/client-get-client-by-abn',
		GET_ACN_CLIENT_BY_ACN_NUMBER:
			'https://bpapiprod.deltainsurance.co.nz/client-get-acn-clients-by-acn',
		GET_ACN_CLIENTS_BY_NAME:
			'https://bpapiprod.deltainsurance.co.nz/client-get-acn-clients-by-name',
		GET_CLIENT_SUBOCCUPATION_BY_ABN_NUMBER:
			'https://bpapiprod.deltainsurance.co.nz/client-get-suboccupation',
		GET_BROKER_DETAILS_BY_ID: 'https://bpapiprod.deltainsurance.co.nz/broker-get-broker-by-id',
		GET_PACKAGES_BY_SUBOCCUPATION_ID_AND_ENTITY_CODE:
			'https://bpapiprod.deltainsurance.co.nz/quote-get-products-by-occupation-and-entity',
		GET_QUOTE_GROUP_BY_QUOTE_ID:
			'https://bpapiprod.deltainsurance.co.nz/quote-quote-group-by-group-id',
		GET_QUOTE_GROUPS_BY_BROKER_ID:
			'https://bpapiprod.deltainsurance.co.nz/quote-get-firm-quote-groups-by-broker-id',
		CREATE_QUOTE_GROUP: 'https://bpapiprod.deltainsurance.co.nz/quote-create-quote-group',
		UPDATE_QUOTE_GROUP: 'https://bpapiprod.deltainsurance.co.nz/quote-update-quote-group',
		UPDATE_QUOTE_GROUP_STATUS_TO_REFERRAL_APPROVED_MODIFIABLE:
			'https://bpapiprod.deltainsurance.co.nz/update-quote-group-status-to-referral-approved-modifiable',
		BIND_QUOTE_GROUP: 'https://bpapiprod.deltainsurance.co.nz/quote-bind-guote-group',
		REFER_QUOTE_GROUP: 'https://bpapiprod.deltainsurance.co.nz/quote-quote-group-referral',
		GET_POLICY_WORDING: 'https://bpapiprod.deltainsurance.co.nz/quote-get-policy-wording',
		GET_WORDING_BY_QUOTE_ID: 'https://bpapiprod.deltainsurance.co.nz/quote-get-wording-by-quote-id',
		GET_DOCUMENT_BY_QUOTE_ID: 
			'https://bpapiprod.deltainsurance.co.nz/quote-get-document',
	} as IEndpoints,
};

export const endpoints = { ...endpointsReference[currentEnv] };
